module.exports = __webpack_public_path__ + "img/scheme2.1012ab26.png";